/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

module.exports = listCacheClear;



/** WEBPACK FOOTER **
 ** node_modules/lodash/_listCacheClear.js
 **/